import _ from "lodash";
import h from "../core/createElement";
import Btn from "./btn";

export default function MultipleBtns({ btns = [], defaultSelected = 0, onChange }) {
    let selected = defaultSelected;

    const
        btns_array = btns,
        btn_els = _.map(btns_array, (e, i) => <Btn title={e.label} containerClass={i == selected ? "selected" : ""} onClick={() => rotate(i)} />);

    const rotate = (index) => {
        selected = index;

        _.forEach(btn_els, (e, i) => {
            e.classList.remove("selected");
            if (i == selected) e.classList.add("selected");
        });

        onChange && onChange(selected);
    };

    return <article class="multiple-btn">{btn_els}</article>;
};